import { GET_SETTING } from './actionTypes';

const actionGetSetting = (payload) => ({
  type: GET_SETTING,
  payload,
});

export default actionGetSetting;
